import { motion, useReducedMotion } from 'framer-motion';

function FadeInSection({ children, delay = 0, y = 24 }) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      initial={{ opacity: reduced ? 1 : 0, y: reduced ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: reduced ? 0 : 0.6, ease: [0.22, 1, 0.36, 1], delay: reduced ? 0 : delay }}
    >
      {children}
    </motion.div>
  );
}

export default FadeInSection;
